<template>
  <div>
    <div v-if="$route.path.indexOf('detail') === -1">
      <div class="header-row">
        <h3 class="page-title">调查问卷推送情况统计报表</h3>
        <div class="header-actions">
          <router-link :to="buildDetailRoute()" class="action-link">明细列表数据</router-link>
          <el-button type="success" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
        </div>
      </div>

      <el-card shadow="never" class="filter-card">
        <el-form :inline="true" label-width="90px">
          <el-form-item label="关联场景">
            <el-select v-model="params.scene_type" placeholder="不限" style="width: 180px;">
              <el-option label="不限" value=""></el-option>
              <el-option label="售后维修" :value="2"></el-option>
              <el-option label="新机设置" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商HQID">
            <el-input v-model="params.dealer_hq_id" clearable placeholder="请输入经销商HQID" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="经销商名称">
            <el-input v-model="params.dealer_name" clearable placeholder="请输入经销商名称" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="Apple ID">
            <el-input v-model="params.shop_code" clearable placeholder="请选择Apple ID" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item v-if="showExpandFilters" label="门店名称">
            <el-input v-model="params.distributor_name" clearable placeholder="请输入门店名称" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item v-if="showExpandFilters" label="开始日期">
            <el-date-picker
              v-model="startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 180px;"
              :picker-options="pickerOptions"
              @change="onStartDateChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="showExpandFilters" label="结束日期">
            <el-date-picker
              v-model="endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 180px;"
              :picker-options="pickerOptions"
              @change="onEndDateChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchData">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="expand-trigger" @click="showExpandFilters = !showExpandFilters">
          {{ showExpandFilters ? '收起筛选' : '展开筛选' }}
          <i :class="showExpandFilters ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
      </el-card>

      <el-table v-loading="loading" :data="list" stripe border :height="wheight - 360">
        <el-table-column prop="dealer_hq_id" label="经销商HQID" min-width="120"></el-table-column>
        <el-table-column prop="dealer_name" label="经销商名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channel_rtm" label="渠道RTM" min-width="110"></el-table-column>
        <el-table-column prop="shop_code" label="AppleID" min-width="120"></el-table-column>
        <el-table-column prop="distributor_name" label="门店名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="scene_type" label="关联场景" min-width="100">
          <template slot-scope="scope">
            {{ sceneTypeText(scope.row.scene_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="activity_id" label="活动ID" min-width="90"></el-table-column>
        <el-table-column prop="service_complete_count" label="服务完成数量" min-width="120"></el-table-column>
        <el-table-column prop="should_push_count" label="应推送数量" min-width="120"></el-table-column>
        <el-table-column prop="push_success_count" label="推送成功数量" min-width="120"></el-table-column>
        <el-table-column prop="feedback_success_count" label="反馈成功数量" min-width="120"></el-table-column>
        <el-table-column prop="push_date" label="推送日期" min-width="120"></el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="params.page"
        :page-size="params.page_size"
        :page-sizes="[20, 50, 100]"
        :total="totalCount"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getQuestionnairePushStatisticsSummary } from '@/api/datacube'

export default {
  name: 'questionnairepushstatistics',
  data () {
    return {
      loading: false,
      exportLoading: false,
      startDate: '',
      endDate: '',
      showExpandFilters: true,
      list: [],
      totalCount: 0,
      params: {
        page: 1,
        page_size: 20,
        push_date_start: '',
        push_date_end: '',
        scene_type: '',
        dealer_hq_id: '',
        dealer_name: '',
        shop_code: '',
        distributor_name: ''
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    sceneTypeText (sceneType) {
      return Number(sceneType) === 2 ? '售后维修' : '新机设置'
    },
    onStartDateChange (val) {
      this.params.push_date_start = val || ''
    },
    onEndDateChange (val) {
      this.params.push_date_end = val || ''
    },
    searchData () {
      this.params.page = 1
      this.getList()
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.page_size = pageSize
      this.getList()
    },
    getList () {
      this.loading = true
      getQuestionnairePushStatisticsSummary(this.params).then(res => {
        const data = (res.data && res.data.data) ? res.data.data : {}
        this.list = data.list || []
        this.totalCount = Number(data.total_count || 0)
      }).catch(() => {
        this.$message.error('获取问卷推送统计失败')
      }).finally(() => {
        this.loading = false
      })
    },
    exportData () {
      this.exportLoading = true
      const query = {
        ...this.params,
        export: 1
      }
      getQuestionnairePushStatisticsSummary(query).then(res => {
        if (res.data && res.data.data && res.data.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
          return
        }
        this.$message({
          type: 'error',
          message: '无内容可导出 或 执行失败，请检查重试'
        })
      }).catch(() => {
        this.$message.error('导出失败，请稍后重试')
      }).finally(() => {
        this.exportLoading = false
      })
    },
    buildDetailRoute (row = {}) {
      return {
        path: this.matchHidePage('detail'),
        query: {
          push_date_start: row.push_date || this.params.push_date_start || '',
          push_date_end: row.push_date || this.params.push_date_end || '',
          scene_type: String(row.scene_type || this.params.scene_type || ''),
          dealer_hq_id: row.dealer_hq_id || this.params.dealer_hq_id || '',
          dealer_name: row.dealer_name || this.params.dealer_name || '',
          shop_code: row.shop_code || this.params.shop_code || '',
          distributor_name: row.distributor_name || this.params.distributor_name || ''
        }
      }
    },
    initDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
      const format = date => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
      }
      this.startDate = format(start)
      this.endDate = format(end)
      this.params.push_date_start = this.startDate
      this.params.push_date_end = this.endDate
    }
  },
  mounted () {
    this.initDefaultDate()
    this.getList()
  }
}
</script>

<style scoped>
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.page-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.action-link {
  color: #409EFF;
  font-size: 13px;
  border: 1px solid #d9ecff;
  padding: 6px 10px;
  border-radius: 4px;
}
.filter-card {
  margin-bottom: 12px;
}
.expand-trigger {
  color: #409EFF;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}
</style>
